var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"banner-image",attrs:{"src":_vm.$vuetify.breakpoint.smAndDown ? _vm.mobileBannerImage : _vm.desktopBannerImage,"alt":"Superior Banner"},on:{"click":function($event){return _vm.goTo('/games/superior')}}})])}
var staticRenderFns = []

export { render, staticRenderFns }